import { Select } from "antd";
import { IconArrowDown, IconDirection } from "@icons/index";
import { VIDEO_SPECS_SELECT_CLASS } from "./constants";
import type { SpecsSelectProps, VideoSpecsOption } from "./types";

interface AspectRatioSelectProps extends SpecsSelectProps {
  value: string;
  options: VideoSpecsOption<string>[];
  onChange: (value: string) => void;
}

export function AspectRatioSelect({ value, options, disabled, onChange }: AspectRatioSelectProps) {
  return (
    <Select
      size="large"
      disabled={disabled}
      value={value}
      onChange={onChange}
      options={options}
      className={VIDEO_SPECS_SELECT_CLASS}
      popupMatchSelectWidth={false}
      prefix={
        <IconDirection
          className={`h-[16px] w-[16px] text-kds-fg-subtle ${value === "RATIO_16_9" ? "rotate-90" : ""}`}
        />
      }
      suffixIcon={<IconArrowDown className="h-[16px] w-[16px] text-kds-fg-subtle" />}
    />
  );
}
